import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import './PartnerDemoPages.css';

const DEMO_STATUS = {
  overall: 'Compliant',
  riskLevel: 'Medium',
  lastAssessed: '2025-01-15',
  frameworks: [
    { name: 'ISO 27001', status: 'Compliant', score: '92%' },
    { name: 'QCB Requirements', status: 'Compliant', score: '88%' },
    { name: 'GDPR', status: 'In progress', score: '75%' },
  ],
};

export default function DemoPartnerStatus() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Compliance status</span>
      </nav>
      <header className="page-header">
       
        <p className="page-subtitle mb-0">
          How your organization is viewed by requesting institutions. Last assessment summary.
        </p>
      </header>

      <Row className="mb-4 g-3">
        <Col md="6" lg="4">
          <div className="stat-card stat-success">
            <div className="stat-label">Overall status</div>
            <div className="stat-value">{DEMO_STATUS.overall}</div>
            <div className="stat-meta">Last assessed: {DEMO_STATUS.lastAssessed}</div>
          </div>
        </Col>
        <Col md="6" lg="4">
          <div className="stat-card">
            <div className="stat-label">Risk level</div>
            <div className="stat-value">
              <span className="badge-partner badge-warning">{DEMO_STATUS.riskLevel}</span>
            </div>
          </div>
        </Col>
      </Row>

      <div className="card-partner">
        <div className="card-header-partner">By framework</div>
        <div className="card-body-partner">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Framework</th>
                <th>Status</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_STATUS.frameworks.map((f) => (
                <tr key={f.name}>
                  <td>{f.name}</td>
                  <td>
                    <span className={`badge-partner ${f.status === 'Compliant' ? 'badge-success' : 'badge-warning'}`}>
                      {f.status}
                    </span>
                  </td>
                  <td>{f.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
